import React, { useState, useEffect } from 'react';
import { getJoinInterviewersDetails, endMeetingForAll, interviewerGetMeetingEndedReason } from '../../../../../services/util/interviews';
import { Col, Row, Container, Card, Form } from 'react-bootstrap';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { CustomAlertBox } from '../../../../shared/customAlertBox';
import CSSLoader from '../../../../shared/cssLoader';
import { CustomMessagePopUpBox } from '../../../../shared/customMessagePopUpBox';
import { Formik } from 'formik';
import styles from './InterviewView.module.scss';
import {
    useMeetingManager,
    MicSelection,
    SecondaryButton,
    CameraSelection,
    SpeakerSelection,
    PreviewVideo,
    PrimaryButton,
    Presenter,
    LeaveMeeting,
    AudioInputControl,
    VideoInputControl,
    AudioOutputControl,
    IconButton,
    Phone,
    Modal,
    ModalHeader,
    ModalBody,
    ModalButtonGroup,
    ModalButton,
    ContentShareControl,
    LocalVideo,
    useLocalVideo,
    useRemoteVideoTileState,
    RemoteVideo,
    ContentShare,
    useContentShareState,
    useMeetingStatus,
    useAttendeeStatus,
    useRosterState,
    RosterGroup,
    RosterAttendee,
    Attendees,
    Badge,
    Laptop,
    Chat,
    useAudioVideo,
    ChatBubble,
    ChatBubbleContainer
} from 'amazon-chime-sdk-component-library-react';
import { MeetingSessionConfiguration } from 'amazon-chime-sdk-js';
import ReactGA from 'react-ga';
import { boolean } from 'yup';
import { CustomConfirmationModal } from '../../../../shared/customConfirmationModal';
import { CustomButton } from '../../../../shared/customButton';
import { CustomTextArea } from '../../../../shared/customTextArea';
import ChatBox from '../../../../shared/chatBox';
import * as yup from 'yup';
const moment = require('moment');
require('moment-duration-format');

const InterviewView = (props) => {
    const { tiles, tileIdToAttendeeId } = useRemoteVideoTileState();

    let { sharingAttendeeId, isLocalUserSharing } = useContentShareState();
    const { isVideoEnabled, toggleVideo } = useLocalVideo();
    const meetingManager = useMeetingManager();
    const meetingStatus = useMeetingStatus();
    const constraints = window.constraints = {
        audio: true,
        video: true
    };
    const audioVideo = useAudioVideo();
    let [chat_message, setChatMessage] = useState([]);
    let [numberOfMessages, setNumberOfMessages] = useState(0);


    let [meetingLoading, setMeetingLoading] = useState(false);

    const [loadingJoinInterview, setLoadingJoinInterview] = useState();
    const [loadingDeviceTest, setLoadingDeviceTest] = useState();
    const [startInterviewLoading, setStartInterviewLoading] = useState();
    const [deviceAccessError, setDeviceAccessError] = useState();
    const [showDeviceAccessErrorPopUp, setShowDeviceAccessErrorPopUp] = useState(false);
    const [showDeviceAccessSuccessPopUp, setShowDeviceAccessSuccessPopUp] = useState(false);
    const [showInterviewStartConstraintsPopUp, setShowInterviewStartConstraintsPopUp] = useState(false);
    const [showMeetingEndedMsgPopup, setShowMeetingEndedMsgPopup] = useState(false);
    const [showMeetingEndedDueToExternalLinkPopup, setShowMeetingEndedDueToExternalLinkPopup] = useState(false);
    const [showJoinInterviewErrorPopUp, setShowJoinInterviewErrorPopUp] = useState(false);
    let [showLeaveOrEndMeetingConfirmationPopup, setShowLeaveOrEndMeetingConfirmationPopup] = useState(false);

    let [meetingEndedByThisUser, setMeetingEndedByThisUser] = useState(false);


    let [localAttendeeId, setLocalAttendeeId] = useState();
    let [selectedAttendeeId, setSelectedAttendeeId] = useState();
    let [joinMeetingLoading, setJoinMeetingLoading] = useState(false);
    let [viewID, setViewID] = useState(1);
    let [selectedTileID, setSelectedTileID] = useState(null);
    let [cancelMeeting, setCancelMeeting] = useState(false);
    let [isInterviewStartGracePeriodPassed, setIsInterviewStartGracePeriodPassed] = useState(false);
    let [currentDateAndTime, setcurrentDateAndTime] = useState();
    let [sheduledDateAndTime, setsheduledDateAndTime] = useState();
    let [differenceBetweenScheduleAndCurrentTimeInMinutes, setDifferenceBetweenScheduleAndCurrentTimeInMinutes] = useState();
    let [durationTime, setdurationTime] = useState();
    let [isInterviewSheduleExpired, setIsInterviewSheduleExpired] = useState(false);
    let [applicationMeetingStatus, setAppicationMeetingStatus] = useState(0);
    let { videoEnabled } = useAttendeeStatus(selectedAttendeeId);

    const { roster } = useRosterState();
    const attendees = Object.values(roster);
    const [sidebarRosterType, setSidebarRosterType] = useState(1);
    let [showControls, setShowControls] = useState(false);
    const fullScreenHandler = useFullScreenHandle();

    const attendeeItems = attendees.map((attendee, index) => {
        const { chimeAttendeeId, name, externalUserId } = attendee;
        let string = externalUserId;
        let result = string.split(/-(.+)/);
        let value = result[1];
        return (
            <RosterAttendee key={chimeAttendeeId} attendeeId={chimeAttendeeId} subtitle={value} />
        );
    });
    let numberOfAttendees = attendees.length;

    const schema = yup.object({
        message: yup.string().trim().required('Required'),
    });


    const triggerMeetingEndedAcknowledgementPopup = async () => {
        let respond = await interviewerGetMeetingEndedReason(props.sessionID);
        if (respond.success === true && respond.data.ended_due_to_external_meeting) {
            setShowMeetingEndedDueToExternalLinkPopup(true); // show external meeting shared msg popup
        } else {
            setShowMeetingEndedMsgPopup(true); // show meeting ended msg popup
        }
    }

    if (applicationMeetingStatus !== meetingStatus) {
        setAppicationMeetingStatus(meetingStatus)
        if (meetingStatus === 1) {
            setViewID(3);
            setJoinMeetingLoading(false)
        }
        else if (meetingStatus === 3 && !meetingEndedByThisUser) {
            triggerMeetingEndedAcknowledgementPopup();
        }
        else if (meetingStatus == 2 || meetingStatus == 6) {
            setJoinMeetingLoading(false)
        }

    }

    //check if interview expired or have more time to schedule 
    const checkInterviewStartConstraints = () => {
        //get props values
        const sheduledDateTime = props.sheduleTime.date_time
        const timeZone = props.sheduleTime.time_zone

        //get current time
        let nowObj = moment().tz(timeZone);

        //convert sheduledtime to moment object
        let shedlued = moment.tz(sheduledDateTime, timeZone)

        //convert current date and time, sheduled time to readable manner
        let currentDateAndTime = moment(nowObj).format('LLLL');
        let sheduledDateAndTime = moment(shedlued).format('LLLL');
        setcurrentDateAndTime(currentDateAndTime);
        setsheduledDateAndTime(sheduledDateAndTime);

        let current_time_utc = moment().utc();
        let scheduled_time_utc = moment(sheduledDateTime);

        let time_difference = parseInt(moment.duration(scheduled_time_utc.diff(current_time_utc)).asMinutes());
        setDifferenceBetweenScheduleAndCurrentTimeInMinutes(time_difference);

        //check sheduled date is passed
        let isInterviewSheduleExpired = shedlued < nowObj;


        setIsInterviewSheduleExpired(isInterviewSheduleExpired);

        if (isInterviewSheduleExpired) {

            let timeDiff = nowObj.diff(shedlued,'minutes');

            if (timeDiff > 45) {
                setIsInterviewStartGracePeriodPassed(true);
            }
        }
        //get time difference from two dates
        var timeDifference = moment.duration(nowObj.diff(shedlued));
        let durationTime = timeDifference.format("w [weeks],d [days],h [hours], m [minutes]");
        let durationTimeFinal = durationTime.replace('-', '');
        setdurationTime(durationTimeFinal)

        setShowInterviewStartConstraintsPopUp(true);
    }

    const closeInterviewStartConstraintsPopups = () => {
        setShowInterviewStartConstraintsPopUp(false);
    }

    const joinMeeting = async () => {
        setStartInterviewLoading(true);
        setMeetingLoading(true);
        setMeetingEndedByThisUser(false);
        // Fetch the meeting and attendee data from your server
        let respond = await getJoinInterviewersDetails(props.sessionID);
        if (respond.success === true && respond.data && respond.data.meeting && respond.data.attendee) {
            const id = respond.data.attendee.Attendee.AttendeeId.toString();
            await setLocalAttendeeId(id)
            // Use the join API to create a meeting session
            const meetingSessionConfiguration = new MeetingSessionConfiguration(respond.data.meeting, respond.data.attendee);
            await meetingManager.join(meetingSessionConfiguration);

            setShowInterviewStartConstraintsPopUp(false);
            setStartInterviewLoading(false);
            setMeetingLoading(false);
            setViewID(2);
        } else if (respond.success === true && respond.data && respond.data.already_ended_due_to_external_meeting) {

            setShowMeetingEndedDueToExternalLinkPopup(true);
            setShowInterviewStartConstraintsPopUp(false)
            setStartInterviewLoading(false);
            setMeetingLoading(false);
        }
        else {
            setStartInterviewLoading(true);
            setMeetingLoading(false);
            openJoinInterviewErrorPopup()
        }
    };

    const openJoinInterviewErrorPopup = () => {
        setShowJoinInterviewErrorPopUp(true);
    }

    const closeJoinInterviewErrorPopup = () => {
        setShowJoinInterviewErrorPopUp(false);
        window.location.reload();
    }

    const startMeeting = async () => {
        await meetingManager.start();
        setJoinMeetingLoading(true);
    }

    const leaveMeeting = async () => {
        setMeetingLoading(true);
        await meetingManager.leave();
        setMeetingLoading(false);
        setShowLeaveOrEndMeetingConfirmationPopup(false);
        setViewID(1);
    }

    const endMeeting = async (id) => {
        setCancelMeeting(true);
        setMeetingLoading(true);
        setMeetingEndedByThisUser(true);
        let respond = await endMeetingForAll(id);
        if (respond.success === true) {
            setCancelMeeting(false)
            await meetingManager.leave();
            setMeetingLoading(false);
            setShowLeaveOrEndMeetingConfirmationPopup(false)
            setViewID(1);
        } else {
            setCancelMeeting(false)
            setMeetingLoading(false);
        }
    }

    // refresh page either meeting ended or external meeting shared
    const meetingEndedMsgAcknowledgement = () => {
        setShowMeetingEndedDueToExternalLinkPopup(false);
        setShowMeetingEndedMsgPopup(false);
        setMeetingEndedByThisUser(false);
        window.location.reload();
    }

    const endSession = () => {
        setShowLeaveOrEndMeetingConfirmationPopup(true);
    }

    // check if browser permissions enabled to access camera and mic
    const CheckDeviceAccess = (check_and_join_meeting) => {

        if (check_and_join_meeting) {
            setLoadingJoinInterview(true);
        }
        else {
            setLoadingDeviceTest(true);
        }
        navigator.mediaDevices.getUserMedia(constraints).then(function success(stream) {
            // if user clicked Join interview option
            if (check_and_join_meeting) {
                checkInterviewStartConstraints();
                setLoadingJoinInterview(false);
            } else { //else, just show the permission ok message
                setShowDeviceAccessSuccessPopUp(true)
                setLoadingDeviceTest(false);
            }

        }).catch(function (err) {
            if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError") {
                setDeviceAccessError("Camera or Microphone not found");
                setShowDeviceAccessErrorPopUp(true);
            } else if (err.name == "NotReadableError" || err.name == "TrackStartError") {
                setDeviceAccessError("Microphone or Camera already in use by a different application ");
                setShowDeviceAccessErrorPopUp(true);
            } else if (err.name == "NotAllowedError" || err.name == "PermissionDeniedError") {
                setDeviceAccessError("Microphone or Camera permissions denied in browser ");
                setShowDeviceAccessErrorPopUp(true);
            } else {
                setDeviceAccessError("Failed to connect with Microphone or Camera. Please try again later");
                setShowDeviceAccessErrorPopUp(true);
            }
            setLoadingDeviceTest(false);
        });
    }

    const closeDeviceAccessTestPopups = () => {
        setShowDeviceAccessSuccessPopUp(false);
        setShowDeviceAccessErrorPopUp(false);
        setLoadingJoinInterview(false);
        setDeviceAccessError(null)
    }


    const updateSelectedAtendeeStatus = (tileid) => {
        if (!tileid || (tileid === '-2')) {
            setSelectedAttendeeId(null)
        }
        else if (tileid === '-1') {
            setSelectedAttendeeId(localAttendeeId)
            setSelectedAttendeeId(localAttendeeId)
        }
        else {
            const id = (tileIdToAttendeeId[tileid]).toString();
            setSelectedAttendeeId(id)
            setSelectedAttendeeId(id)
        }
    }

    const viewControls = () => {
        setShowControls(true)
        let timeout;
        (() => {
            clearTimeout(timeout);
            timeout = setTimeout(() => setShowControls(false), 3500);
        })();
    }

    //send chat message
    const sendChatData = (text, { resetForm }) => {
        const mess = {
            action: 'outgoing',
            cmd: "TEXT",
            data: text.message,
            createdDate: moment().format('hh:mm A'),
            senderName: localStorage.getItem('name')
        }
        audioVideo.realtimeSendDataMessage('chat', JSON.stringify(mess));
        resetForm({ message: '' });
        setChatMessage([...chat_message, mess])
    }

    //chat message receive
    const receiveChatData = (mess) => {
        if (sidebarRosterType !== 3) {
            let count = numberOfMessages + 1;
            setNumberOfMessages(count);
        }
        const data = JSON.parse(mess.text());
        data.action = 'incoming';
        setChatMessage([...chat_message, data]);
    }

    //chat data useEffect
    useEffect(() => {
        if (audioVideo) {
            audioVideo.realtimeSubscribeToReceiveDataMessage(
                'chat',
                receiveChatData
            );

            return () => {
                audioVideo.realtimeUnsubscribeFromReceiveDataMessage('chat');
            }
        }

    }, [audioVideo, chat_message, numberOfMessages, sidebarRosterType])

    useEffect(() => {
        if (sidebarRosterType === 3) {
            setNumberOfMessages(0);
        }
    }, [sidebarRosterType]);


    useEffect(() => {
        setSelectedAttendeeId(null);
        setSelectedTileID(null)
    }, [videoEnabled]);

    useEffect(() => {
        if (meetingStatus === 1) {
            toggleVideo();
        }
    }, [meetingStatus])


    useEffect(
        () => {
            return () => {
                leaveMeeting();
            };
        },
        [props.isLeaving],
    );

    useEffect(() => {
        let pageHit = '/app/company/interview-review';
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(pageHit);
    }, [])

    return (
        <div>
            {
                showLeaveOrEndMeetingConfirmationPopup && (
                    <Modal size="md" onClose={() => setShowLeaveOrEndMeetingConfirmationPopup(false)} rootId="modal-root">
                        <ModalHeader title="End Meeting" />
                        <ModalBody>
                            <p>Leave meeting or you can end the meeting for all. The meeting cannot be used once it ends.</p>
                            <ModalButtonGroup
                                primaryButtons={[
                                    <div>
                                        <ModalButton onClick={leaveMeeting} label="Leave Meeting" variant="primary" key="leaveMeeting" disabled={meetingLoading === true ? true : false} />
                                        <ModalButton onClick={() => { endMeeting(props.sessionID) }} label="End meeting for all" variant="primary" key="endMeeting"
                                            icon={cancelMeeting === true ? <i className="fas fa-spinner fa-spin"></i> : null}
                                            disabled={cancelMeeting === true ? true : false}
                                        />
                                    </div>
                                ]}
                                secondaryButtons={[
                                    <ModalButton
                                        onClick={() => setShowLeaveOrEndMeetingConfirmationPopup(false)}
                                        label="Cancel"
                                        key="cancelBtn"
                                        variant="secondary"
                                    />
                                ]}
                            />
                        </ModalBody>
                    </Modal>
                )
            }

            {/* device access success popup */}
            <CustomMessagePopUpBox
                show={showDeviceAccessSuccessPopUp}
                confirmationType='success'
                cancelIconclick={() => { closeDeviceAccessTestPopups() }}
                onPrimaryBtnClick={() => { closeDeviceAccessTestPopups() }}
                topic="Test Successful"
                message="No issues detected. Both Microphone and Camera work properly"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Ok!"
                is_a_success_message={true}
            />
            {/* device access error popup */}
            <CustomMessagePopUpBox
                show={showDeviceAccessErrorPopUp}
                confirmationType='danger'
                cancelIconclick={() => { closeDeviceAccessTestPopups() }}
                onPrimaryBtnClick={() => { closeDeviceAccessTestPopups() }}
                topic="Test Failed"
                message={deviceAccessError}
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Ok!"
                isExternalLinkAvailable={true}
                externalLinkLable="Learn how to enable permissions."
                externalLink="https://hiretrace.io/documentation/interviews/browser-permissions"
            />

            {/* start interview alert confirmation start */}
            <CustomConfirmationModal
                show={showInterviewStartConstraintsPopUp}
                confirmationType='success'
                cancelIconclick={() => closeInterviewStartConstraintsPopups()}
                onSecondaryBtnClick={() => closeInterviewStartConstraintsPopups()}
                onPrimaryBtnClick={joinMeeting}
                showToolTip={((differenceBetweenScheduleAndCurrentTimeInMinutes > 5) || isInterviewStartGracePeriodPassed) ? true : false}
                toolTipId='interview_constaints_tip_id'
                toolTip={(differenceBetweenScheduleAndCurrentTimeInMinutes > 5) ? 'Too early to start the interview' : 'Scheduled time is passed by 45mins.'}
                isPrimaryBtnDisabled={((isInterviewStartGracePeriodPassed) || (differenceBetweenScheduleAndCurrentTimeInMinutes > 5) || startInterviewLoading) ? true : false}
                isSecondaryBtnDisabled={startInterviewLoading ? true : false}
                primaryBtnBackSideIcon={startInterviewLoading ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Start"
                confirmationMessage={
                    <div>
                        <Container>
                            <div className={styles.alertLabelDiv}>
                            <p className={styles.alertLabels}>Interview scheduled date and time:<br /><span className={styles.alertValues}>{sheduledDateAndTime}</span><br /><span className={styles.alertValues}>({props.sheduleTime.time_zone})</span></p><br />
                            <p className={styles.alertLabels}>Current date and time:<br /><span className={styles.alertValues}>{currentDateAndTime}</span><br /><span className={styles.alertValues}>({props.sheduleTime.time_zone})</span></p><br />
                            {isInterviewSheduleExpired === false && isInterviewStartGracePeriodPassed === false &&
                                <div>
                                    <p className={styles.alertLabels}>To start interview you have <span className={styles.alertValues}>{durationTime}</span>.</p><br />
                                    <p className={styles.alertLabelsWarning}>{(differenceBetweenScheduleAndCurrentTimeInMinutes > 5) ? 'Cannot start the interview yet. Interview Start option will be enabled 5mins before the scheduled time' : 'Do you want to start the interview now?'}</p>
                                </div>
                            }

                            {isInterviewSheduleExpired === true && isInterviewStartGracePeriodPassed === false &&
                                <p className={styles.alertLabelsWarning}>You have missed your interview time by <span className={styles.alertLabelsWarning}>{durationTime}</span>. But still you can start the interview</p>
                            }
                            {isInterviewSheduleExpired === true && isInterviewStartGracePeriodPassed === true &&
                                <p className={styles.alertLabelsDanger}>You have missed your interview time by <span className={styles.alertValuesDanger}>{durationTime}</span>. So you cannot start this interview. Please reschedule</p>
                            }

                            {!((differenceBetweenScheduleAndCurrentTimeInMinutes > 5) || isInterviewStartGracePeriodPassed) &&
                                <div className={styles.interviewStartMsg}>
                                    <CustomAlertBox
                                        alertType='dangerAlert'
                                        alertBodyText='When you click "Start", the candidate will receive an interview started email notification'
                                    />
                                </div>}

                            </div>
                        </Container>
                    </div>
                }
            />
            {/* interview ended msg popup */}
            {
                <CustomMessagePopUpBox
                    show={showMeetingEndedMsgPopup}
                    confirmationType='default'
                    cancelIconclick={() => { meetingEndedMsgAcknowledgement() }}
                    onPrimaryBtnClick={() => { meetingEndedMsgAcknowledgement() }}
                    topic="Interview Ended"
                    message={"This interview has been ended by another interviewer"}
                    primaryBtnName="submitBtn"
                    primaryBtnType="button"
                    primaryBtnCssType="successBtn"
                    primaryBtnLabel="Ok!"
                />
            }
            {/* external meeting link shared msg popup */}
            {
                <CustomMessagePopUpBox
                    show={showMeetingEndedDueToExternalLinkPopup}
                    confirmationType='default'
                    cancelIconclick={() => { meetingEndedMsgAcknowledgement() }}
                    onPrimaryBtnClick={() => { meetingEndedMsgAcknowledgement() }}
                    topic="An Alternative Meeting URL Shared"
                    message={"An alternative meeting url is shared. Please click 'Ok' to refresh the page and get updated interview joining details"}
                    primaryBtnName="submitBtn"
                    primaryBtnType="button"
                    primaryBtnCssType="successBtn"
                    primaryBtnLabel="Ok!"
                />
            }
            {/* Error during joining the interview */}
            <CustomMessagePopUpBox
                show={showJoinInterviewErrorPopUp}
                confirmationType='danger'
                cancelIconclick={() => closeJoinInterviewErrorPopup()}
                onPrimaryBtnClick={() => closeJoinInterviewErrorPopup()}
                topic="Something went Wrong !"
                message="Error occured when connecting you to the interview. Please contact support@hiretrace.io"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Ok!"
            />


            <div>
                {viewID === 1 ?
                    (<Row className={styles.buttonContainingRow}>
                        <SecondaryButton
                            label="Test Audio/Video"
                            onClick={() => CheckDeviceAccess(false)}
                            icon={loadingDeviceTest === true ? <i className="fas fa-spinner fa-spin"></i> : null}
                            className={styles.customButton}
                            disabled={loadingDeviceTest === true ? true : false}
                        />

                        <SecondaryButton
                            label="Start / Join Interview"
                            onClick={() => CheckDeviceAccess(true)}
                            icon={loadingJoinInterview === true ? <i className="fas fa-spinner fa-spin"></i> : null}
                            className={styles.customPrimaryButton}
                            disabled={loadingJoinInterview === true ? true : false}
                        />
                    </Row>)
                    : viewID === 2 ?
                        (
                            <div>
                                <Container className={styles.cameraPreviewContainer}>
                                    <Row>
                                        <Col sm={6} className={styles.audioDiv}>
                                            <div className={styles.dropdownItemContainerColumn}>
                                                <p className={styles.topicLabel}>Audio</p>
                                                <div className={styles.settingDiv}>
                                                    <MicSelection />
                                                </div>
                                                <div>
                                                    <SpeakerSelection />
                                                </div>
                                                <p className={styles.topicLabel}>Video</p>
                                                <div>
                                                    <CameraSelection />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm={6}>
                                            <div className={styles.dropdownItemContainerColumn}>
                                                <div>
                                                    <p className={styles.topicLabel}>Video Preview</p>
                                                    <PreviewVideo />
                                                </div>

                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className={styles.actionRowPreview}>
                                        <Col className="text-left">
                                            <SecondaryButton label="Leave Meeting" disabled={meetingLoading === true && viewID === 2 ? true : false} icon={meetingLoading === true && viewID === 2 ? <i className="fas fa-spinner fa-spin"></i> : <LeaveMeeting />} onClick={leaveMeeting} />
                                        </Col>
                                        <Col className="text-right">
                                            <PrimaryButton label='Join Meeting' disabled={(joinMeetingLoading === true && viewID === 2 && applicationMeetingStatus === 0) ? true : false} icon={(joinMeetingLoading === true && viewID === 2 && applicationMeetingStatus === 0) ? <i className="fas fa-spinner fa-spin"></i> : <Presenter />} onClick={startMeeting} />
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        )
                        : viewID === 3 ?

                            (<div>
                                <Row className={styles.videoPosition}>
                                    <Col sm={3} className={styles.rosterSide} id={styles.rosterid}>
                                        
                                        {/* video tiles */}
                                        {sidebarRosterType === 1 ?
                                            <Row className={styles.tileOuterBox}>
                                                {(tiles.length>0 || ((selectedTileID !== '-1') && isVideoEnabled) || (sharingAttendeeId && (selectedTileID !== '-2')) ) &&
                                                    <div className={styles.tilesMessageBox}>
                                                        <CustomAlertBox
                                                            alertBodyText={
                                                                <div >&nbsp;&nbsp;Click on tiles to enlarge</div>
                                                            }
                                                            alertType='dangerAlert'
                                                        />
                                                    </div>
                                                    
                                                }
                                                {tiles.map(tileId => (selectedTileID !== tileId) && (<Col sm={6} onClick={() => { updateSelectedAtendeeStatus(tileId); setSelectedTileID(tileId); }} className={styles.oneRemoteVideoScreenSize}><RemoteVideo tileId={tileId} key={tileId} /></Col>))}
                                                {((selectedTileID !== '-1') && isVideoEnabled) &&
                                                    (<Col sm={6} className={styles.oneRemoteVideoScreenSize} onClick={() => { updateSelectedAtendeeStatus('-1'); setSelectedTileID('-1'); }}>
                                                        <LocalVideo />
                                                    </Col>)
                                                }
                                                {(sharingAttendeeId && (selectedTileID !== '-2')) &&
                                                    (<Col sm={6} className={styles.oneRemoteVideoScreenSize} onClick={() => { updateSelectedAtendeeStatus('-2'); setSelectedTileID('-2'); }}>
                                                        <ContentShare />
                                                    </Col>)
                                                }
                                                {(!isVideoEnabled && !sharingAttendeeId && (tiles.length < 1)) &&
                                                    <Card className={styles.cardNoPreview}>
                                                        <Card.Body className={styles.cardBodyNoPreview}>
                                                            <p className={styles.mainScreenText}>No video inputs to preview</p>
                                                        </Card.Body>
                                                    </Card>
                                                }
                                            </Row>
                                            // participant list
                                            : sidebarRosterType === 2 ?
                                                <div >
                                                    <RosterGroup className={styles.attendeesbox}>{attendeeItems}</RosterGroup>
                                                </div>
                                                // chat
                                                : sidebarRosterType === 3 &&
                                                <div>
                                                    <div className={styles.chatContainer}>
                                                        {chat_message.length > 0 &&
                                                            chat_message.map((values, index) => (
                                                                <ChatBox
                                                                    variant={values.action}
                                                                    senderName={values.senderName}
                                                                    timestamp={values.createdDate}
                                                                    keyIndex={index}
                                                                    content={values.data}
                                                                />
                                                            ))
                                                        }
                                                    </div>
                                                    <div className={styles.textBoxContainer}>
                                                        <Formik
                                                            validationSchema={schema}
                                                            initialValues={{}}
                                                            onSubmit={(values, resetForm) => sendChatData(values, resetForm)}>
                                                            {({
                                                                handleSubmit,
                                                                handleChange,
                                                                values
                                                            }) => (
                                                                <div>
                                                                    <Form noValidate onSubmit={handleSubmit}>
                                                                        <CustomTextArea
                                                                            name="message"
                                                                            handleChange={handleChange}
                                                                            values={values.message || ''}
                                                                        />
                                                                        <div>
                                                                            <CustomButton
                                                                                buttonType="submit"
                                                                                type="primaryBtn"
                                                                                label="Send"
                                                                            />
                                                                        </div>
                                                                    </Form>
                                                                </div>
                                                            )}
                                                        </Formik>
                                                    </div>
                                                </div>
                                        }

                                    </Col>
                                    {/* middle video/screen share component */}
                                    <Col className={styles.mainVideoBackgroundCol} onMouseMove={() => viewControls()}>
                                        <Card className={styles.mainVideoBackgroundCard}>
                                            <Card.Body className={styles.mainVideoBackground} onMouseMove={() => viewControls()}>
                                                <FullScreen handle={fullScreenHandler} className={styles.fullscreenContainer}>
                                                    {(!!selectedTileID && (selectedTileID !== '-1') && (selectedTileID !== '-2')) &&
                                                        <RemoteVideo tileId={selectedTileID} />
                                                    }
                                                    {(!!selectedTileID && (selectedTileID == '-1') && isVideoEnabled) &&
                                                        <LocalVideo />
                                                    }
                                                    {(!!selectedTileID && (selectedTileID == '-2') && !!sharingAttendeeId) &&
                                                        <ContentShare />
                                                    }

                                                    {/* show controllers in full screen mode */}
                                                    {fullScreenHandler.active === true &&
                                                        <Col xs={4} className={showControls === true ? `${styles.buttonRowOutlineHover} ${styles.showcontrols}` : styles.buttonRowOutlineHover}>
                                                            <Row className={styles.actionBtnInnerRow}>
                                                                <AudioInputControl />
                                                                <AudioOutputControl />
                                                                <VideoInputControl />
                                                                <div onClick={() => { setSelectedTileID('-2') }}><ContentShareControl /></div>
                                                                <IconButton
                                                                    icon={<i className="fas fa-compress-arrows-alt"></i>}
                                                                    onClick={fullScreenHandler.exit}
                                                                    className={styles.videoTileBtn}
                                                                />
                                                            </Row>
                                                        </Col>
                                                    }
                                                </FullScreen>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    {/* contollers */}
                                    <Col sm={3} className={styles.rosterColumn}>
                                        <div>
                                            {sidebarRosterType === 2 ?
                                                <IconButton
                                                    icon={<Attendees />}
                                                    badge={<Badge value={numberOfAttendees} className={styles.attendeesNoBadge} />}
                                                    selected={boolean('Selected', true)}
                                                    onClick={() => setSidebarRosterType(2)}
                                                />
                                                :
                                                <IconButton
                                                    icon={<Attendees />}
                                                    badge={<Badge value={numberOfAttendees} className={styles.attendeesNoBadge} />}
                                                    onClick={() => setSidebarRosterType(2)}
                                                />
                                            }
                                            {sidebarRosterType === 1 ?
                                                <IconButton
                                                    icon={<Laptop />}
                                                    selected={boolean('Selected', true)}
                                                    onClick={() => setSidebarRosterType(1)}
                                                    className={styles.videoTileBtn}
                                                />
                                                :
                                                <IconButton
                                                    icon={<Laptop />}
                                                    onClick={() => setSidebarRosterType(1)}
                                                    className={styles.videoTileBtn}
                                                />
                                            }
                                            {sidebarRosterType === 3 ?
                                                <IconButton
                                                    icon={<Chat />}
                                                    selected={boolean('Selected', true)}
                                                    onClick={() => setSidebarRosterType(3)}
                                                    className={styles.videoTileBtn}
                                                />
                                                :
                                                <IconButton
                                                    icon={<Chat />}
                                                    badge={numberOfMessages !== 0 && <Badge value={numberOfMessages} className={styles.attendeesNoBadge} />}
                                                    onClick={() => setSidebarRosterType(3)}
                                                    className={styles.videoTileBtn}
                                                />
                                            }
                                        </div>
                                    </Col>
                                    <Col className={styles.controlsDiv}>
                                        <Row className={styles.videoControlsDiv}>
                                            <AudioInputControl />
                                            <AudioOutputControl />
                                            <VideoInputControl />
                                            <div onClick={() => { setSelectedTileID('-2') }}><ContentShareControl /></div>
                                            <IconButton icon={<Phone />} onClick={endSession} className={styles.endMeetingBtn} />
                                            <IconButton
                                                icon={<i className="fas fa-expand-arrows-alt"></i>}
                                                onClick={fullScreenHandler.enter}
                                                className={styles.videoTileBtn}
                                            />
                                        </Row>
                                    </Col>
                                </Row>
                            </div>)
                            :
                            (applicationMeetingStatus == 2 || applicationMeetingStatus == 6) ?

                                (
                                    <Row className={styles.buttonContainingRow}>
                                        <Card className={styles.interviewBodyErrorMsgBox}>
                                            <p className={styles.interviewBodyErrorMsgText}>Something went wrong. Try refreshing the page</p>
                                        </Card>
                                    </Row>
                                ) : null

                }
            </div>

        </div>
    )
}

export default InterviewView;
